import styled from 'styled-components'
import { mapTheme } from 'etymos'
import mapBreakpointsExtended from 'utils/mapBreakpointsExtended'

const getColumnDisplay = ({ flex }) => (flex ? 'flex' : 'block')

// prettier-ignore
const Column = styled.div`
	box-sizing: border-box;
	display: ${getColumnDisplay};
	${mapTheme((breakpoint, props) => (props.gutter ?? breakpoint.gutter) && `
    padding-left: ${(props.gutter ?? breakpoint.gutter) / 2}px;
    padding-right: ${(props.gutter ?? breakpoint.gutter) / 2}px;
  `)}
	${mapBreakpointsExtended((value, props, breakpoint) => `
    width: ${(value === 'span' ? 1 : (value < 1 ? value : (value / (props.columns || breakpoint.columns)))) * 100}%;
    max-width: ${(value === 'span' ? 1 : (value < 1 ? value : (value / (props.columns || breakpoint.columns)))) * 100}%;
    display: ${value > 0 || value === 'span' ? getColumnDisplay(props) : 'none'};
  `)}
  ${p => getColumnDisplay(p) === 'flex' && `
  	flex-direction: column;
  	align-items: ${p.align || 'flex-start'};
		justify-content: ${p.justify || 'flex-start'};
  `}
`

// prettier-ignore
const Row = styled.div`
	box-sizing: border-box;
	flex: 1;
	display: flex;
	flex-direction: ${p => p.direction || 'row'};
	flex-wrap: wrap;
	align-items: ${p => p.align || 'flex-start'};
	justify-content: ${p => p.justify || 'flex-start'};
	${mapTheme((breakpoint, props) => (props.gutter ?? breakpoint.gutter) && !props['vertical-gutter'] && `
    margin-left: ${(props.gutter ?? breakpoint.gutter) / -2}px;
    margin-right: ${(props.gutter ?? breakpoint.gutter) / -2}px;
    max-width: calc(100% + ${(props.gutter ?? breakpoint.gutter)}px);
  `)}
  ${mapTheme((unused, props) => (props.gutter) && `
    & ${Column} {padding: 0 ${(props.gutter) / 2}px;}
  `)}
	${mapTheme((breakpoint, props) => (props.gutter ?? breakpoint.gutter) && props['vertical-gutter'] && `
    margin: ${(props.gutter ?? breakpoint.gutter) / -2}px;
    & ${Column} {padding: ${(props.gutter ?? breakpoint.gutter) / 2}px;}
  `)}
`

const Grid = { Row, Column }

export default Grid
